// /////////////////////////////////////////////////////////////
// [ファイル] CrmCustomerDetailPage.tsx
// [概要] 顧客詳細・編集の全画面ページ (方式 Y)
//        URL /crm/customers/:id でアクセス。
//        親 Layout (CrmCustomerLayout) の Context から refresh() を取得し、
//        編集成功時に一覧側のデータを最新化したうえで /crm/customers へ戻る。
// /////////////////////////////////////////////////////////////
import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import CrmCustomerForm from '../components/CrmCustomerForm';
import { useCrmTableContext } from '../providers/CrmTableProvider';

export default function CrmCustomerDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useCrmTableContext();

  // 一覧から渡された URL Query (?tab=corporate&page=2 等) を保持して戻る
  // location.state.listSearch があればそれを優先、無ければ素の /crm/customers へ
  const handleBackToList = () => {
    const state = location.state as { listSearch?: string } | null;
    const searchPart = state?.listSearch || '';
    navigate(`/crm/customers${searchPart}`);
  };

  // 編集成功時は一覧データを再取得（Form 内で setIsEditing(false) 済みなので同ページに留まる）
  const handleSuccess = (_savedId: string) => {
    refresh();
  };

  return (
    <CrmCustomerForm
      customerId={id}
      isModal={false}
      onClose={handleBackToList}
      onSuccess={handleSuccess}
    />
  );
}
